import { getQueryParams as getQuery } from 'components/utils';

export const getQueryParams = (formState) => {
  const queryObj = { ...formState };
  //   console.log('queryObj', queryObj);
  //   delete queryObj.org_country;
  //   delete queryObj.state;
  return getQuery(queryObj);
};
